import ScrollMagic from 'scrollmagic'
import { TweenMax, TimelineMax } from 'gsap'
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

import OverlayCopyBlocks from './OverlayCopyBlocks'
import ParallaxImages from './ParallaxImages'
import Animate from './Animate'
import QuoteBlocks from './QuoteBlocks'
import Carousels from './Carousels'
import LineByLineBlocks from './LineByLineBlocks'
import CaseStudyIntro from './CaseStudyIntro'
import HomepageManifesto from './HomepageManifesto'

export default (function() {

  // let scrollHandler = null
  let scrollController;
  let showIndicators = false;//location.href.indexOf('.vm') !== -1;
  function init() {

    // Destroy the previously used scroll controller
    if (scrollController) {
      scrollController.destroy(true)
    }

    scrollController = new ScrollMagic.Controller({ addIndicators: showIndicators });

    [
      OverlayCopyBlocks,
      ParallaxImages,
      Animate,
      QuoteBlocks,
      Carousels,
      LineByLineBlocks,
      CaseStudyIntro,
      HomepageManifesto,

    ].forEach((ScrollMotion) => {
      ScrollMotion.init(scrollController)
    })

    // Main header/navigation
    const menu = document.querySelector('.menu')
    const headerNav = document.querySelector('.header')
    const footer = document.querySelector('.footer')
    const topScroll = document.querySelector('.top-scroll')

    const scrollTopProperty = typeof window.scrollY === "undefined" ? 'pageYOffset' : 'scrollY'
    let lastScrollPosition = window[scrollTopProperty]

    const homeHeroContainer = document.querySelector('.page.home .hero')
    window.addEventListener('optimizedScroll', () => {

      let currentScrollY = window[scrollTopProperty];
      if (currentScrollY < 0) {
        return;
      }

      let direction = lastScrollPosition < currentScrollY && 'down' || 'up';

      if (homeHeroContainer) {
        let homeHeroPercentage = currentScrollY / homeHeroContainer.offsetHeight
        if (homeHeroPercentage > 1) {
          toggleMomentsThatMove(false)
        } else if (direction == 'up' && homeHeroPercentage < .34) {
          toggleMomentsThatMove(true)
        }
      }

      if (!menu.classList.contains('active')) {
        if (headerNav) {
          const classes = {
            pinned: 'active',
            unpinned: 'inactive',
          }

          headerNav.classList[currentScrollY == 0 ? 'add' : 'remove']('active-top')

          if (direction == 'up') {
            if (headerNav.classList.contains(classes.unpinned)) {
              headerNav.classList.remove(classes.unpinned);
              headerNav.classList.add(classes.pinned);
            }
          } else {
            if (headerNav.classList.contains(classes.pinned) || !headerNav.classList.contains(classes.unpinned)) {
              headerNav.classList.remove(classes.pinned);
              headerNav.classList.add(classes.unpinned);
            }
          }
        }

        if (topScroll) {
          const top = topScroll.offsetTop + window[scrollTopProperty]
          const height = topScroll.offsetHeight
          const percenageToTop = top / window.innerHeight

          let footerTop = (footer.offsetTop - window[scrollTopProperty]) / window.innerHeight
          if (percenageToTop > 2.6) {
            topScroll.classList.add('show')
          } else {
            topScroll.classList.remove('show')
          }

          if(footerTop < 1){
            topScroll.classList.remove('u-position-fixed')
            topScroll.classList.add('u-position-absolute')
          } else {
            topScroll.classList.remove('u-position-absolute')
            topScroll.classList.add('u-position-fixed')
          }
        }
      }

      lastScrollPosition = window[scrollTopProperty]
    })

    // if (document.readyState == 'complete') {
    //   setTimeout(function() {
    //     scrollHandler();
    //   }, 250)
    // } else {
    //   window.addEventListener('load', scrollHandler)
    // }
  }

  return {
    init
  }

})();
